import { gsap } from 'gsap'

/* Central GSAP entry point. Import `gsap` from here (never from 'gsap' directly)
 * so every animation in the app shares one configured instance. */

gsap.config({
    nullTargetWarn: false,
    force3D: true
})

gsap.defaults({
    ease: 'power2.out',
    duration: 0.8
})

export { gsap }
